module.exports = __webpack_public_path__ + "img/1688.21943108.png";